export class ImpersonationLogModel
{
    public ID: string;
    public UserID: string;
    public ClientID: string;
    public StartTime: Date;
    public EndTime: Date;
}